import { computed } from 'vue';

import useAuth from '@/composables/useAuth';
import { useIntegrationProfileStore } from '@/stores';
import { API_FILTER_INTEGRATION_TYPE } from '@/types/integration_profiles';

import { MAX_API_FILTERS_PER_ORG } from './constants';

export default function useApiFilterCreateGate() {
  const integrationProfileStore = useIntegrationProfileStore();
  const { hasScope } = useAuth();

  const canWrite = computed(() => hasScope('write:integrations'));

  const filterCount = computed(
    () =>
      integrationProfileStore.getIntegrationProfilesByType(
        API_FILTER_INTEGRATION_TYPE,
      ).length,
  );

  const createDisabledReason = computed(() =>
    !canWrite.value
      ? 'Your role cannot create API filters.'
      : filterCount.value >= MAX_API_FILTERS_PER_ORG
        ? `You've reached the limit of ${MAX_API_FILTERS_PER_ORG} API filters per organization. Remove an existing filter to create a new one.`
        : undefined,
  );

  return { canWrite, filterCount, createDisabledReason };
}
